<template>
  <div id="app" data-app="true">
   <!-- <v-app>  -->
    <Header />
    <!-- <div id="headerDivider" style="text-align: center"></div> -->
    
    <div class="flexContainer">
    <Nav />
    <div class="container" id="mainContainer">
    
    <div class="underNavHeader"><div class="underNavLeft"><span>Updated {{timestamp}}</span> | <span style="font-weight: bold" class="amber">Includes President’s new goal of 200M vaccinations in 100 days</span></div><div class="underNavRight printHide"><a href="https://iem-modeling.com/" target="_blank">Forecast Model >>></a></div></div>
    <!-- <transition name="fade" mode="out-in"> -->
    <router-view/>
    <!-- </transition> -->
    </div>
    <Footer />
  </div>
  <!-- </v-app> -->
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
import Nav from '@/components/Nav.vue';
import { mapState } from 'vuex';
import '@/styles/styles.css';
import '@/styles/map.css';
import '@/styles/print.css';

export default {
  components: {
    Footer,
    Header,
    Nav
  },
  computed: {
    ...mapState(['timestamp'])
  },
  created() {
    document.title = "IEM COVID-19 Vaccination Modeling";
    this.$store.dispatch('init', this.$route.query);
  }
}
</script>
